module.exports = __webpack_public_path__ + "acae4b0faf0126d1d62252fa2d50e105.svg";